import { useEffect, useState } from "react";
import { FaTheaterMasks } from 'react-icons/fa';
import { BsStars } from 'react-icons/bs';
import { GiTrophyCup } from 'react-icons/gi';
import { bandApi } from "../Api/api";

function Dashboard() {
  const [bandCount, setBandCount] = useState(0);
  const [amateursCount, setAmateursCount] = useState(0);
  const [professionalsCount, setProfessionalsCount] = useState(0);

  useEffect(() => {
    bandApi.getAllBands()
    .then((res) => {
      setBandCount(res.data.length);
    })
    .catch(() => {
      setBandCount(0);
    });
    bandApi.getAmateurs()
    .then((res) => {
      setAmateursCount(res.data.length);
    })
    .catch(() => {
      setAmateursCount(0);
    })
    bandApi.getProfessionals()
    .then((res) => {
      setProfessionalsCount(res.data.length);
    })
    .catch(() => {
      setProfessionalsCount(0);
    });
  }, []);

  return (
    <div className="page page-dashboard">

      <div className="body">
      <h1 className="titluDashboard">Numărul de trupe înscrise</h1>
        <div className="controllers">
          <div className="card-container">
            <h1><GiTrophyCup />
              <p>Categorie Profesioniști</p>
              <p>{professionalsCount}</p>
            </h1>
          </div>
          <div className="card-container">
            <h1><FaTheaterMasks />
              <p>Total Trupe</p>
              <p>{bandCount}</p>
            </h1>
          </div>
          <div className="card-container">
            <h1><BsStars />
              <p>Categorie Amatori</p>
              <p>{amateursCount}</p>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;